type SystemIconProps = React.SVGProps<SVGSVGElement>;

const SystemIcon: React.FC<SystemIconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="-16 -20.5 100 100"
      fill="none"
      {...props}
    >
      <path
        d="M0.251465 10.6777L16.5539 20.4458V50.9607L0.251465 41.1927V10.6777Z"
        fill="#DDB96E"
      />
      <path
        d="M12.6913 36.6858C13.1996 36.3813 14.0094 36.7982 14.5 37.6171C14.9907 38.4359 14.9764 39.3467 14.4682 39.6512C13.9599 39.9558 13.1501 39.5388 12.6594 38.7199C12.1688 37.9011 12.183 36.9903 12.6913 36.6858Z"
        fill="#7C612E"
      />
      <path
        d="M14.1667 37.8784C13.8118 37.2861 13.2261 36.9845 12.8584 37.2048L11.0218 38.3065L12.3 40.456L14.1437 39.3498C14.5113 39.1295 14.5217 38.4707 14.1667 37.8784Z"
        fill="#F9E4B9"
      />
      <path
        d="M14.1454 39.3494C14.5131 39.1291 14.5234 38.4703 14.1685 37.878L11.6626 39.3808L12.3018 40.4556L14.1454 39.3494Z"
        fill="#BB9446"
      />
      <path
        d="M11.0547 38.2872C11.4224 38.0669 12.0082 38.3685 12.3631 38.9608C12.718 39.5531 12.7077 40.2119 12.34 40.4322C11.9724 40.6525 11.3866 40.3509 11.0317 39.7585C10.6768 39.1662 10.6871 38.5074 11.0547 38.2872Z"
        fill="#F2D497"
      />
      <path
        d="M0.248535 10.6793L16.553 20.4459L32.7486 10.7276L16.4386 0.960919L0.248535 10.6793Z"
        fill="#F9E4B9"
      />
      <path
        d="M16.5518 20.4459L32.7474 10.7256V41.2405L16.5518 50.9608V20.4459Z"
        fill="#7C612E"
      />
      <path
        d="M25.7563 24.5054L46.7535 37.1037V58.1009L25.7563 45.5026V24.5054Z"
        fill="#DDB96E"
      />
      <path
        d="M25.7563 24.5053L46.7535 37.1036L67.7514 24.5055L46.7488 11.9072L25.7563 24.5053Z"
        fill="#F9E4B9"
      />
      <path
        d="M46.7534 37.1037L67.7506 24.5054V45.5026L46.7534 58.1009V37.1037Z"
        fill="#7C612E"
      />
      <path
        d="M59.6755 24.5054C59.6755 28.9351 53.8901 32.526 46.7535 32.526C39.6169 32.526 33.8315 28.9351 33.8315 24.5054C33.8315 20.0758 39.6169 16.4849 46.7535 16.4849C53.8901 16.4849 59.6755 20.0758 59.6755 24.5054Z"
        fill="#7C612E"
      />
      <path
        d="M38.4812 19.4317C39.5994 18.7295 40.9479 18.1689 42.4508 17.7972C43.7816 17.4681 45.2334 17.2871 46.7533 17.2871V24.5056L54.8482 19.3228C55.7894 19.8892 56.5768 20.5536 57.1678 21.2894C57.9456 22.2578 58.3831 23.35 58.3831 24.5056H46.7533L54.8482 29.6885C53.7659 30.3399 52.4801 30.8618 51.0558 31.214C49.725 31.5431 48.2732 31.7241 46.7533 31.7241V24.5056L38.4812 29.5795C37.6181 29.0375 36.8923 28.411 36.3388 27.7219C35.561 26.7534 35.1235 25.6612 35.1235 24.5056H46.7533L38.4812 19.4317Z"
        fill="#F2D497"
      />
      <path
        d="M46.7523 27.7137C49.6069 27.7137 51.9211 26.2773 51.9211 24.5055V22.147H41.5835V24.5055C41.5835 26.2773 43.8976 27.7137 46.7523 27.7137Z"
        fill="#DDB96E"
      />
      <path
        d="M46.753 27.7137C49.6076 27.7137 51.9218 26.2773 51.9218 24.5055V22.147H46.7529L46.753 27.7137Z"
        fill="#7C612E"
      />
      <path
        d="M51.9216 22.1472C51.9216 23.919 49.6074 25.3554 46.7528 25.3554C43.8981 25.3554 41.584 23.919 41.584 22.1472C41.584 20.3753 43.8981 18.939 46.7528 18.939C49.6074 18.939 51.9216 20.3753 51.9216 22.1472Z"
        fill="#F9E4B9"
      />
    </svg>
  );
};

export default SystemIcon;
